import * as THREE from 'three';

// Geometry, materials, light values and orthographic camera from the reference.
export function createSpatial(canvas) {
    const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:true });
    renderer.setClearColor(0x000000, 0);
    const scene3 = new THREE.Scene();
    const camera = new THREE.OrthographicCamera(-7, 7, 4.6, -4.6, 0.1, 50);
    camera.position.set(0, 0, 10);
    camera.lookAt(0, 0, 0);

    function makeEllipse(rx, ry, color, opacity, rot=0, z=0) {
        const curve = new THREE.EllipseCurve(0,0,rx,ry,0,Math.PI*2,false,rot);
        const pts = curve.getPoints(220).map(p => new THREE.Vector3(p.x,p.y,z));
        const geo = new THREE.BufferGeometry().setFromPoints(pts);
        const mat = new THREE.LineBasicMaterial({color,transparent:true,opacity});
        return new THREE.LineLoop(geo,mat);
    }
    const orbit1 = makeEllipse(5.55,2.62,0x8D84EA,.42,.03,-1);
    const orbit2 = makeEllipse(5.15,2.15,0xA8C8F8,.26,-.08,-1.2);
    const orbit3 = makeEllipse(4.55,1.72,0xC9C5F4,.22,.12,-1.4);
    scene3.add(orbit1,orbit2,orbit3);

    const sphereGeo = new THREE.SphereGeometry(.18,32,32);
    const sphereMats = [
        new THREE.MeshPhongMaterial({color:0x6F72EC,shininess:140,specular:0xffffff}),
        new THREE.MeshPhongMaterial({color:0xB6A6FF,shininess:140,specular:0xffffff}),
        new THREE.MeshPhongMaterial({color:0xFFD0AE,shininess:140,specular:0xffffff}),
        new THREE.MeshPhongMaterial({color:0x7DE2D7,shininess:140,specular:0xffffff})
    ];
    const balls = [
        {a:2.9,rx:5.55,ry:2.62,s:.72,m:0,z:.3},
        {a:1.35,rx:5.55,ry:2.62,s:.48,m:0,z:.15},
        {a:.2,rx:5.15,ry:2.15,s:.46,m:2,z:.1},
        {a:5.7,rx:5.55,ry:2.62,s:.56,m:1,z:.2},
        {a:4.25,rx:5.15,ry:2.15,s:.42,m:1,z:.12}
    ].map((d,i) => {
        const b = new THREE.Mesh(sphereGeo,sphereMats[d.m]);
        b.scale.setScalar(d.s);
        b.userData = {...d,phase:i*.8};
        b.position.set(Math.cos(d.a)*d.rx, Math.sin(d.a)*d.ry, d.z);
        scene3.add(b);
        return b;
    });
    scene3.add(new THREE.AmbientLight(0xffffff,1.6));
    const dl = new THREE.DirectionalLight(0xffffff,1.4);
    dl.position.set(3,4,7); scene3.add(dl);
    const pl = new THREE.PointLight(0xC8C3FF,.7,20);
    pl.position.set(-4,2,6); scene3.add(pl);
    let currentX = 0, currentY = 0;

    function render(t, targetX, targetY, orbitBoost, reduced) {
        currentX += (targetX-currentX)*.035;
        currentY += (targetY-currentY)*.035;
        camera.position.x = reduced ? 0 : currentX*.10;
        camera.position.y = reduced ? 0 : -currentY*.06;
        camera.lookAt(0,0,0);
        if (!reduced) {
            balls.forEach((b,i) => {
                const d = b.userData;
                const a = d.a+t*(.055+i*.004)*orbitBoost;
                b.position.set(Math.cos(a)*d.rx,Math.sin(a)*d.ry,d.z);
            });
            orbit1.rotation.z = Math.sin(t*.15)*.012;
            orbit2.rotation.z = Math.cos(t*.14)*.010;
        }
        orbit1.material.opacity += ((orbitBoost>1 ? .62 : .42)-orbit1.material.opacity)*.08;
        orbit2.material.opacity += ((orbitBoost>1 ? .42 : .26)-orbit2.material.opacity)*.08;
        orbit3.material.opacity += ((orbitBoost>1 ? .34 : .22)-orbit3.material.opacity)*.08;
        renderer.render(scene3,camera);
    }
    function resize(width, height) {
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1,2));
        // Drawing buffer follows the displayed host, not the full logical artboard.
        renderer.setSize(width,height,false);
    }
    function dispose() {
        [orbit1,orbit2,orbit3].forEach(o => {o.geometry.dispose();o.material.dispose();});
        sphereGeo.dispose(); sphereMats.forEach(m => m.dispose());
        renderer.dispose();
    }
    return { render, resize, dispose };
}
